"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const variantEnclosedColored = props => {
    const { colorScheme: c } = props;
    return {
        tab: {
            backgroundColor: 'lilac.50',
            color: 'gray.600',
            fontWeight: '600',
            borderColor: 'lilac.50',
            borderTopRadius: 'md',
            clipPath: 'inset(-20px -20px 0px -20px)',
            _selected: {
                color: 'blue.400',
                backgroundColor: 'white',
                borderColor: 'white',
                borderTopColor: 'white',
                boxShadow: '4px 0px 20px rgba(68, 68, 68, 0.201295)',
                _focus: {
                    boxShadow: '4px 0px 20px rgba(68, 68, 68, 0.201295)',
                    backgroundColor: `${c}.400`,
                    color: 'white',
                    borderColor: `${c}.400`,
                },
            },
            _hover: {
                backgroundColor: `${c}.400`,
                color: 'white',
                borderColor: `${c}.400`,
            },
        },
    };
};
const variants = {
    'enclosed-colored': variantEnclosedColored,
};
const defaultProps = {
    size: 'md',
    variant: 'enclosed-colored',
    colorScheme: 'purple',
};
const TabsStyles = {
    variants,
    defaultProps,
};
exports.default = TabsStyles;
